import { SITE_URL } from "../../../../common/constants"

const links = {
  privacy: `${SITE_URL}/privacy/`,
  terms: `${SITE_URL}/terms/`,
  faq: "https://help.buoyhealth.com/",
}

const privacyCardConfig = {
  title: "Your privacy. Our priority.",
  sections: [
    {
      type: "text",
      text: "Nothing is more personal than your health information. That's why we've implemented measures to protect the security and privacy of your data. ",
    }, {
      type: "link",
      text: "Learn more",
      path: links.faq,
    }, {
      type: "text",
      text: ", or visit our ",
    }, {
      type: "link",
      text: "privacy policy",
      path: links.privacy,
    }, {
      type: "text",
      text: " and ",
    }, {
      type: "link",
      text: "terms of use",
      path: links.terms,
    },  {
      type: "text",
      text: ".",
    },
  ]
}
export { privacyCardConfig as default }



// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/components/PrivacyCardConfig.js